import img_game_logo from 'assets/images/game_logo.min.png';
import mPlayerWrapper, {
  PlayerListener,
  Animation,
} from 'spine-player/spine-player-wrapper';

import board from 'assets/images/board.min.png';

import t from 'assets/images/t.min.png';
import mine from 'assets/images/mine.min.png';
import prize from 'assets/images/prize.min.png';
import boardLow from 'assets/images/boardLow.min.png';
import boardLowSmall from 'assets/images/boardLowSmall.min.png';
import boardTop from 'assets/images/boardTop.min.png';
import laternLeft from 'assets/images/lanternLeft.min.png';
import laternRight from 'assets/images/lanternRight.min.png';
import img_explosion from 'assets/images/explosion.min.png';
import sound_button_enable from 'assets/sounds/button_enable.mp3';
import sound_button_hover from 'assets/sounds/button_hover.mp3';
import sound_dynamite_explosion from 'assets/sounds/dynamite_explosion.mp3';
import sound_game_starter from 'assets/sounds/game_starter.mp3';
import sound_gold_reveal from 'assets/sounds/gold_reveal.mp3';
import sound_stone_click from 'assets/sounds/stone_click.mp3';
import sound_stone_hover from 'assets/sounds/stone_hover.mp3';
import sound_win from 'assets/sounds/win.mp3';
import main_theme from 'assets/sounds/main_theme.mp3';
import sad from 'assets/sounds/sad.mp3';
import happy from 'assets/sounds/happy.mp3';
import encourage from 'assets/sounds/encourage.mp3';
import sleepy from 'assets/sounds/sleepy.mp3';

import { TFiles } from './types';

export const files: TFiles = {
  image: [
    img_game_logo,
    board,
    t,
    mine,
    prize,
    boardLow,
    boardLowSmall,
    boardTop,
    laternLeft,
    laternRight,
  ],
  fetch: [
    sound_button_enable,
    sound_button_hover,
    sound_dynamite_explosion,
    sound_game_starter,
    sound_gold_reveal,
    sound_stone_click,
    sound_stone_hover,
    sound_win,
    main_theme,
    sad,
    happy,
    encourage,
    sleepy,
  ],
  imageToBlob: [img_explosion],
  callback: [
    cb => {
      setTimeout(() => {
        cb();
      }, 1000);
    },
    cb => {
      const listener: PlayerListener = {
        onReady() {
          mPlayerWrapper.unsubscribeListener(listener);
          cb();
        },

        onAnimationStart(animation: Animation) {},
      };

      mPlayerWrapper.subscribeListener(listener);
    },
  ],
};
